/**
 * NF-949: Controller for managing notifications.
 */

/**
 * @class ConnectToChargingPointController
 * Initializes a new instance of the ConnectToChargingPointController.
* @param {angular.ui.IStateService} $state - State service for navigation
* @param {NotificationService} NotificationService
* @param {MKioskService} MKioskService
* @param {$message} $message
* @param {$Loading} $Loading
* @param {AuthService} AuthService
* @param {$q} $q
* @param {ChargeRequestService} ChargeRequestService
* @param {angular.IRootScopeService} $rootScope

*/
// @ts-ignore
function ConnectToChargingPointController($state, NotificationService, MKioskService, $message, $Loading, AuthService, $q, ChargeRequestService, $rootScope) {
    this.$state = $state;
    this.notificationService = NotificationService;
    this.MKioskService = MKioskService;
    this.$message = $message;
    this.$Loading = $Loading;
    this.AuthService = AuthService;
    this.$q = $q;
    this.chargeRequestService = ChargeRequestService;
    this.$rootScope = $rootScope;
}

// Dependency injection for the controller
ConnectToChargingPointController.$inject = ['$state', 'NotificationService', 'MKioskService', '$message', '$Loading', 'AuthService', '$q', 'ChargeRequestService', '$rootScope'];


// Define the prototype methods for NotificationsCtrl
ConnectToChargingPointController.prototype = {

    // Initialize the controller's properties
    /**
     * @type {boolean}
     */
    isNotificationOnNotificationsModule: false,

    /**
     * @type {NotificationModel} notification
     */
    notification: {},

    pageNumber: 0, // 0: main, 1: What Is Issue At Point, 2: report issue, 3: thanks for your report
    feedback: '', // User feedback comment

    init: function () {
        this.pageNumber = 0;
        this.feedback = '';
    },


    /**
     * Make a snooze for this notification
     * Storage snooze time
     * @param delay{number}
     */
    snooze: function (delay) {
        // Mark notification as read
        this.notificationService.snoozeNotification(this.notification, delay)
            .then(() => {
                this.close();
            }, this.$message.error)
            .finally(this.$Loading.blockUI());
    },



    onTakeCareOfItRightAwayClicked: function () {
        this.gotoChargeRequest(this.notification.QueuedChargeRequest.VehicleId).finally(() => {
            this.hide();
        })
    },


    /**
     * Get BookingId from QueuedChargeRequests
     * @param vehicleId {string}
     * @returns {string}
     */
    getChargeMadeUponReturnOfVehicleBookingIdInQueuedChargeRequests(vehicleId) {
        let bookingId;
        let auth = this.AuthService.getAuthenticatedUser();
        if(auth.QueuedChargeRequests && auth.QueuedChargeRequests.length >0) {
            auth.QueuedChargeRequests.forEach((queuedChargeRequest)=>{
                if(queuedChargeRequest.VehicleId === vehicleId){
                    bookingId = queuedChargeRequest.ChargeMadeUponReturnOfVehicleBookingId;
                }
            })
        }
        return bookingId;
    },

    /**
     * Get ChargeMadeUponReturnOfVehicleBookingId from auth.QueuedChargeRequests. If not found, refresh auth.QueuedChargeRequests and try again.
     * @param vehicleId {string}
     * @return {angular.IPromise<string>}
     */
    getChargeMadeUponReturnOfVehicleBookingId(vehicleId){
        return this.$q((resolve)=>{
            let authenticatedUser = this.AuthService.getAuthenticatedUser();
            if(!authenticatedUser.PickUpAndReturnAreManagedByUsersWithDedicatedAccessRight) {
                resolve(null);
            } else {
                let bookingId = this.getChargeMadeUponReturnOfVehicleBookingIdInQueuedChargeRequests(vehicleId);
                if(!bookingId){ // re-try if not found
                    this.AuthService.refreshHomeData().then(() => {
                        bookingId = this.getChargeMadeUponReturnOfVehicleBookingIdInQueuedChargeRequests(vehicleId);
                        resolve(bookingId);
                    }, ()=>{
                        resolve(bookingId);
                    })
                } else{
                    resolve(bookingId);
                }
            }
        })

    },

    /**
     * Go to ChargeRequest
     * @param vehicleId {string}
     * @return angular.IPromise<any>
     */
    gotoChargeRequest: function (vehicleId) {
        // find ChargeMadeUponReturnOfVehicleBookingId
        return this.getChargeMadeUponReturnOfVehicleBookingId(vehicleId)
            .then((vehicleBookingId) => {
                if (vehicleBookingId) {
                    return this.$state.go('internal.chargingrequest', {
                        context: 'vehiclebooking',
                        contextId: vehicleBookingId
                    });
                } else {
                    return this.MKioskService.refreshMyVehicles().then(() => { // make sure my vehicles are up to date
                        return this.$state.go('internal.chargingrequest', {
                            context: 'vehicle',
                            contextId: vehicleId
                        })
                    }, this.$message.error);
                }
            })
            .finally(this.$Loading.blockUI());
    },



    /**
     * @param {string} type
     * @param {string} feedback
     */
    reportIssue(type, feedback) {
        let priorVehicleId = null;
        if (type === 'PriorVehicleIsStillThere' && this.notification.PriorVehicle) {
            priorVehicleId = this.notification.PriorVehicle.Id;
        }

        return this.chargeRequestService.reportChargingPointIssue({
            "SiteId": this.notification.SiteId,
            "IssueType": type,
            "Comment": feedback,
            "MarkChargingPointsAsNotAccessible": true,
            "ChargingPointIds": [this.notification.ChargingPointId],
            "MobileNotificationId": this.notification.Id,
            "PriorVehicleId": priorVehicleId,
        })
            .finally(this.$Loading.blockUI())
            .then(() => {
                this.pageNumber = 3;
            }, this.$message.error);
    },

    confirmReportCharger() {
        this.reportIssue('SpecificChargingPointIssue', this.feedback);
    },

    closeThanksForYourReport() {
       this.$rootScope.$broadcast('refresh-home-data'); // Refresh home data after reporting issue because charging point status have changed
       this.close();
    }
};


// Register the ConnectToChargingPointController controller with the AngularJS module
angular.module('internal.notifications').controller('ConnectToChargingPointController', ConnectToChargingPointController);